/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnsavedInputs */

const en_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved`)
};

const es_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No guardado`)
};

const fr_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non enregistré`)
};

const de_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungespeichert`)
};

const ja_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未保存`)
};

const zh_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未保存`)
};

const ar_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير محفوظ`)
};

const id_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum disimpan`)
};

const it_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non salvato`)
};

const ru_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не сохранено`)
};

const pt_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não guardado`)
};

const ko_unsaved = /** @type {(inputs: UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장되지 않음`)
};

/**
* | output |
* | --- |
* | "Unsaved" |
*
* @param {UnsavedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unsaved = /** @type {((inputs?: UnsavedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnsavedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unsaved(inputs)
	if (locale === "es") return es_unsaved(inputs)
	if (locale === "fr") return fr_unsaved(inputs)
	if (locale === "de") return de_unsaved(inputs)
	if (locale === "ja") return ja_unsaved(inputs)
	if (locale === "zh") return zh_unsaved(inputs)
	if (locale === "ar") return ar_unsaved(inputs)
	if (locale === "id") return id_unsaved(inputs)
	if (locale === "it") return it_unsaved(inputs)
	if (locale === "ru") return ru_unsaved(inputs)
	if (locale === "pt") return pt_unsaved(inputs)
	return ko_unsaved(inputs)
});